import PaintingHero from './components/PaintingHero';
import PaintingServices from './components/PaintingServices';
import PaintTypesElPaso from './components/PaintTypesElPaso';
import ComparisonChecklist from './components/ComparisonChecklist';
import PaintingFAQ from './components/PaintingFAQ';
import ContractorDirectory from './components/ContractorDirectory';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { useEffect } from 'react';

export default function Painting() {
  useEffect(() => {
    document.title = 'Painting Contractors El Paso | Interior & Exterior Painting Services';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Find top-rated painting contractors in El Paso for interior and exterior painting, cabinet refinishing, and color consultation. Get free estimates from licensed professionals.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'painting contractors El Paso, interior painting, exterior painting, cabinet refinishing, house painters');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <PaintingHero />
      <PaintingServices />
      <PaintTypesElPaso />
      <ComparisonChecklist />
      <PaintingFAQ />
      <ContractorDirectory />
      <Footer />
    </div>
  );
}
